module.exports = __webpack_public_path__ + "static/media/menu-2.61d9b82c.png";